import { CHECK_CIRCLE_V2, CLOCK_ICON } from './images';
import { IButtonImageV3 } from '../interfaces/button';
import { TRANSLATIONS_REPORTS } from '../translations/reports';
import { BdsLabelPillVariant } from '../types/types';

export const REPORTS_TABS = [
  {
    title: TRANSLATIONS_REPORTS.rf.tabs.payroll,
    id: 0
  },
  {
    title: TRANSLATIONS_REPORTS.rf.tabs.health,
    id: 2
  },
  {
    title: TRANSLATIONS_REPORTS.rf.tabs.monthly,
    id: 1
  }
];

export const REPORTS_STATUS: {
  [key: string]: { tagVariant: BdsLabelPillVariant; icon: IButtonImageV3 };
} = {
  generated: { tagVariant: 'success', icon: CHECK_CIRCLE_V2 },
  toGenerate: { tagVariant: 'inactive', icon: CLOCK_ICON }
};

export const TAB_INDICES = {
  PAYROLL: 0,
  MONTHLY: 1,
  HEALTH: 2
} as const;

export const WELLBEING_INFO_TYPES = {
  challenges: 'challenges',
  medicalCheckUp: 'medicalCheckUp',
  sleepProblems: 'sleepProblems'
} as const;

export const MEDICAL_CHECK_UP_STORY_IMAGE =
  'https://media.content-mgmt.platform.betterfly.com/content/6ijTuHe-2Am5gUJ2zpP4E';
export const SLEEP_PROBLEMS_STORY_IMAGE =
  'https://media.content-mgmt.platform.betterfly.com/content/A1I3TfAee4NcUjyfLGMke';

export const COUNT_UP_DURATION = 1500;
